import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { useDispatch } from "react-redux";
import { closeModal } from "../../store/actions/modalAction";
import { InformationUI } from "../../components/InformationUI";
import { MEGASIG_PARAMETERS, getOverallStatus } from "./megasig.constant";

const MegasigInfoUi = ({ data, loading }) => {
  const dispatch = useDispatch();

  const formatDate = (value) => {
    if (!value) return "NA";
    const date = new Date(value);
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  };

  const overallStatus = getOverallStatus(data?.status);

  const getStatus = (key) => {
    const status = data?.status?.[key];
    if (!status) return "NA";
    return status;
  };

  return (
    <CustomDialog
      id={"megasigInfo"}
      title={"Megasig Result Details"}
      closeText="Close"
      onClose={() => dispatch(closeModal("megasigInfo"))}
    >
      {loading ? (
        <Box p={4} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <InformationUI
            Data={[
              { label: "Box Id :", value: data?.boxId || "NA" },
              { label: "Created At :", value: formatDate(data?.createdAt) },
            ]}
          />

          <Box mt={2} p={2}>
            <Typography variant="h5" color={overallStatus === "PASS" ? "green" : "error"}>
              Overall Result : {overallStatus}
            </Typography>
          </Box>

          <Box mt={3}>
            <Typography variant="h5" color="primary" p={2}>
              Parameters
            </Typography>
            <Table
              size="small"
              sx={{
                borderCollapse: "collapse",
                "& td, & th": {
                  border: "1px solid #dddddd",
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "rgba(29, 1, 59, 0.08)",
                    }}
                  >
                    Parameter
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "rgba(29, 1, 59, 0.08)",
                    }}
                  >
                    Result
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "rgba(29, 1, 59, 0.08)",
                    }}
                  >
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {MEGASIG_PARAMETERS.map((param) => (
                  <TableRow key={param.key}>
                    <TableCell>{param.label}</TableCell>
                    <TableCell>{data?.[param.key] ?? "NA"}</TableCell>
                    <TableCell>{getStatus(param.key)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      )}
    </CustomDialog>
  );
};

export default MegasigInfoUi;
